import { render, staticRenderFns } from "./taskAssignmentSearchComponent.vue?vue&type=template&id=024cfbcc"
import script from "./taskAssignmentSearchComponent.vue?vue&type=script&lang=js"
export * from "./taskAssignmentSearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports